module.exports = __webpack_public_path__ + "img/title-text.b373a09d.png";